module.exports = __webpack_public_path__ + "img/partner-3.86a97f4a.png";